export enum GenderEnum {
  DER = 'der',
  DIE = 'die',
  DAS = 'das',
  PLURAL = 'plural',
}

export enum PartOfSpeechEnEnum {
  NOUN = 'Noun',
  VERB = 'Verb',
  ADJECTIVE = 'Adjective',
  ADVERB = 'Adverb',
  PRONOUN = 'Pronoun',
  ARTICLE = 'Article',
  NUMERAL = 'Numeral',
  CONJUNCTION = 'Conjunction',
  PREPOSITION = 'Preposition',
  INTERJECTION = 'Interjection',
  PARTICLE = 'Particle',
  PHRASE = 'Phrase',
}

export enum PartOfSpeechRuEnum {
  NOUN = 'Существительное',
  VERB = 'Глагол',
  ADJECTIVE = 'Прилагательное',
  ADVERB = 'Наречие',
  PRONOUN = 'Местоимение',
  ARTICLE = 'Артикль',
  NUMERAL = 'Числительное',
  CONJUNCTION = 'Союз',
  PREPOSITION = 'Предлог',
  INTERJECTION = 'Междометие',
  PARTICLE = 'Частица',
  PHRASE = 'Фраза',
}

export enum LevelEnum {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
}

export enum LanguageEnum {
  EN = 'EN',
  RU = 'RU',
}

export enum ToneModeEnum {
  FLUID = 'Fluid',
  FAITHFUL = 'Faithful',
  CREATIVE = 'Creative',
}

export enum MediaTypeEnum {
  PODCAST = 'PODCAST',
  AUDIOBOOK = 'AUDIOBOOK',
  VIDEO = 'VIDEO',
  SONG = 'SONG',
  COURSE = 'COURSE',
  OTHER = 'OTHER',
}

export enum QuestionDifficultyEnum {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
}

export enum QuizQuestionEnum {
  GENDER = 'gender',
  PLURAL = 'plural',
  TRANSLATION = 'translation',
  CONJUGATION = 'conjugation',
  FILL_IN_BLANK = 'fill-in-blank',
  MIXED_LANGUAGE = 'mixed-language',
  CONTEXTUAL = 'contextual',
  SENTENCE_CONSTRUCTION = 'sentence-construction',
  SYNONYM = 'synonym',
  ANTONYM = 'antonym',
  CROSSWORD = 'crossword',
}

export enum StepColorEnum {
  ROYAL_BLUE = 'ROYAL_BLUE',
  CYAN = 'CYAN',
  BRIGHT_LIME = 'BRIGHT_LIME',
  YELLOW = 'YELLOW',
  ORANGE = 'ORANGE',
  RED = 'RED',
  VIOLET = 'VIOLET',
  GRAY = 'GRAY',
}

export enum BookTypeEnum {
  REGULAR_BOOK = 'REGULAR_BOOK',
  TEXTBOOK = 'TEXTBOOK',
  CUSTOM_TEXT = 'CUSTOM_TEXT',
}
